import ICalibrationGeneral = ZoneIQCalibration.ICalibrationGeneral;
import ICalibrationGeneralImportValidationResult = ZoneIQCalibration.ICalibrationGeneralImportValidationResult;
import { BaseMutableModel } from '../common-models/base-mutable-model.model';

export class CalibrationGeneralValue extends BaseMutableModel<ICalibrationGeneral> implements ICalibrationGeneral {
    ZoneCombinationId: number;
    OverlayTypologyId?: number;
    RevisionId: number;

    PrincipalMaxHeightLvl: number;
    PrincipalBuildingMin?: number;
    Outbuilding?: number;
    FacadePrimaryFrontage?: number;
    FacadeSecondaryFrontage?: number;
    PkgFacadeWidthMax?: number;
    TowerMaxHeightLvl?: number;
    LotAreaMin?: number;
    LotAreaMax?: number;
    LotAreaMinAlley?: number;
    LotAreaMaxAlley?: number;
    LotWidthMin?: number;
    LotWidthMinAlley?: number;
    LotWidthMax?: number;
    GreenSpace?: number;
    LotCoverageFirstFloor?: number;
    LotCoverageSecondFloor?: number;
    TowerFloorplateAreaResidential?: number;
    TowerFloorplateAreaCommercial?: number;
    SecondLayerDimension?: number;
    FLR?: number;
    PFrontSetbackPrincipal?: number;
    PFrontSetbackPrincipalMax?: any;
    PFrontSetbackSecondary?: number;
    PFrontSetbackSecondaryMax?: any;
    PSideSetback?: number;
    PSideSetbackMax?: any;
    PRearSetback?: number;
    PRearSetbackMax?: any;
    OFrontSetbackPrincipal?: number;
    OSideSetback?: number;
    OSideSetbackAtCorner?: number;
    ORearSetback?: number;
    TFrontSetbackPrincipal?: number;
    TFrontSetbackPrincipalMax?: any;
    TFrontSetbackSecondary?: number;
    TFrontSetbackSecondaryMax?: any;
    TSideSetback?: number;
    TSideSetbackMax?: any;
    TRearSetback?: number;
    TRearSetbackMax?: any;
    TSetbackBetweenTowers?: number;
    UFrontSetbackPrincipal?: number;
    UFrontSetbackSecondary?: number;
    USideSetback?: number;
    URearSetback?: number;
    CommonLawn: boolean;
    PorchAndFence: boolean;
    Forecourt: boolean;
    Stoop: boolean;
    Shopfront: boolean;
    Gallery: boolean;
    Arcade: boolean;
    PrincipalMaxHeightFt?: number;
    PrincipalMinHeightFt?: number;
    ActivePrimaryFrontageGround: boolean;
    ActivePrimaryFrontageAbove: boolean;
    ActiveSecondaryFrontageGround: boolean;
    ActiveSecondaryFrontageAbove: boolean;
    ActiveWaterFrontageGround: boolean;
    ActiveWaterFrontageAbove: boolean;
    PenthouseMaxHeightLvl?: any;
    PenthouseMaxHeightFt?: any;
    TowerMaxHeightFt?: any;
    PenthouseFloorPlate?: any;
    PWaterSetback?: number;
    TWaterSetback?: number;
    PeFrontSetbackPrincipal?: number;
    PeFrontSetbackPrincipalMax?: any;
    PeFrontSetbackSecondary?: number;
    PeFrontSetbackSecondaryMax?: any;
    PeSideSetback?: number;
    PeSideSetbackMax?: any;
    PeRearSetback?: number;
    PeRearSetbackMax?: any;
    PSplitSideSetback?: any;
    TerraceOrLightwell: boolean;

    importValidationResult?: ICalibrationGeneralImportValidationResult;

    settings: any = null;

    constructor(data: ICalibrationGeneral, fieldSettings?: any) {
        super(data, ['ZoneCombinationId', 'OverlayTypologyId'], fieldSettings);
        if (data) {
            this.importValidationResult = data.importValidationResult;
        }
    }

    static factory(data: ICalibrationGeneral): CalibrationGeneralValue {
        return new CalibrationGeneralValue(data);
    }
}
